import React from "react";
import { Link } from "react-router-dom";
import MTLogo from "./MTLogo";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-ink" data-testid="site-footer">
      <div className="container-editorial py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 flex items-start gap-5">
          <MTLogo size={48} />
          <div>
            <div className="font-serif text-2xl text-bone tracking-tight">Mensorio</div>
            <div className="overline text-[10px] mt-2">Private Japan, done properly.</div>
            <p className="mt-6 text-bone/55 text-sm leading-relaxed max-w-md">
              Founder-led travel design for discerning global travelers. A limited number of journeys, carefully considered.
            </p>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[10px] mb-5">Navigate</div>
          <ul className="space-y-3 text-sm text-bone/70">
            <li><Link to="/" className="link-underline hover:text-bone" data-testid="footer-nav-home">Home</Link></li>
            <li><Link to="/destinations" className="link-underline hover:text-bone" data-testid="footer-nav-destinations">Destinations</Link></li>
            <li><Link to="/experiences" className="link-underline hover:text-bone" data-testid="footer-nav-experiences">Experiences</Link></li>
            <li><Link to="/about" className="link-underline hover:text-bone" data-testid="footer-nav-about">About</Link></li>
            <li><Link to="/plan" className="link-underline hover:text-bone" data-testid="footer-nav-plan">Plan Your Journey</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-[10px] mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-bone/70">
            <li>By appointment, globally</li>
            <li>
              <a
                href="https://www.linkedin.com/in/taiga-kunii-9a153280/?locale=ja"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline hover:text-bone"
                data-testid="footer-linkedin"
              >
                Founder — LinkedIn
              </a>
            </li>
            <li>
              <Link to="/plan" className="link-underline hover:text-bone" data-testid="footer-plan-link">
                Begin a conversation →
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-bone/40">
          <span>© {new Date().getFullYear()} Mensorio. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">Designed in Japan</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
